import { makeZeroArgHook } from "../../utils/makeZeroArgHook";
import getAcatsTransfers, { url, } from "../requests/getAcatsTransfers";
const useGetAcatsTransfers = makeZeroArgHook(getAcatsTransfers, () => [url()]);
export default useGetAcatsTransfers;
//# sourceMappingURL=useGetAcatsTransfers.js.map